module.exports = __webpack_public_path__ + "static/media/Evelyn-icon-01-01-md.ae08e7ce.png";